/**
 * /advertisers/notifications — TanStack Router route (OPUS FS151).
 *
 * Flat-file naming convention maps `advertisers.notifications.tsx` to the
 * `/advertisers/notifications` URL. Rendering delegated to
 * `AdvertiserNotificationsPage` under the `advertiser-notifications` feature
 * folder so this file stays a lightweight wire-up.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { AdvertiserNotificationsPage } from "@/features/advertiser-notifications/AdvertiserNotificationsPage";

interface AdvertisersNotificationsSearch {
	advertiserId?: string;
	tab?: "subscriptions" | "feed";
}

export const advertisersNotificationsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertisers/notifications",
	validateSearch: (
		raw: Record<string, unknown>,
	): AdvertisersNotificationsSearch => {
		const out: AdvertisersNotificationsSearch = {};
		if (typeof raw.advertiserId === "string" && raw.advertiserId.trim().length > 0) {
			out.advertiserId = raw.advertiserId.trim();
		}
		if (raw.tab === "subscriptions" || raw.tab === "feed") {
			out.tab = raw.tab;
		}
		return out;
	},
	component: AdvertiserNotificationsPage,
});

export default advertisersNotificationsRoute;

export { AdvertiserNotificationsPage } from "@/features/advertiser-notifications/AdvertiserNotificationsPage";
